var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocationMarkerC1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "LocationMarker_C1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "LocationMarker_C1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(9.000000, 7.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15,0 C7.12875,0 0,6.34195455 0,14.1673636 C0,21.9909091 3.75,27.9545455 15,41 C26.25,27.9545455 30,21.9909091 30,14.1673636 C30,6.34195455 22.873125,0 15,0 Z",
    id: "Shape",
    fill: "#124B4F"
  }), /*#__PURE__*/React.createElement("g", {
    id: "C1",
    transform: "translate(6.265625, 8.414062)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.359375,2.015625 C4.44791667,2.015625 3.7421875,2.35807292 3.2421875,3.04296875 C2.7421875,3.72786458 2.4921875,4.68229167 2.4921875,5.90625 C2.4921875,8.453125 3.44791667,9.7265625 5.359375,9.7265625 C6.16145833,9.7265625 7.1328125,9.52604167 8.2734375,9.125 L8.2734375,11.15625 C7.3359375,11.546875 6.2890625,11.7421875 5.1328125,11.7421875 C3.47135417,11.7421875 2.20052083,11.2382812 1.3203125,10.2304688 C0.440104167,9.22265625 0,7.77604167 0,5.890625 C0,4.703125 0.216145833,3.66276042 0.6484375,2.76953125 C1.08072917,1.87630208 1.70182292,1.19140625 2.51171875,0.71484375 C3.32161458,0.23828125 4.27083333,0 5.359375,0 C6.46875,0 7.58333333,0.268229167 8.703125,0.8046875 L7.921875,2.7734375 C7.49479167,2.5703125 7.06510417,2.39322917 6.6328125,2.2421875 C6.20052083,2.09114583 5.77604167,2.015625 5.359375,2.015625 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.875,11.5859375 L13.4609375,11.5859375 L13.4609375,4.9765625 L13.484375,3.890625 L13.5234375,2.703125 C13.1223958,3.10416667 12.84375,3.3671875 12.6875,3.4921875 L11.375,4.546875 L10.2109375,3.09375 L13.890625,0.1640625 L15.875,0.1640625 L15.875,11.5859375 Z",
    id: "Path"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationMarkerC1);
export default __webpack_public_path__ + "static/media/LocationMarker_C1.b088829fdcb52b1332c0ba1c818f5c76.svg";
export { ForwardRef as ReactComponent };